import moment from "moment";
import { useEffect, useRef, useState } from "react"
import { getBundleReport } from "services/reportService";


export const useGetListBundleReport = (params) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState();
    const [error, setError] = useState(null);
    const filterParams = useRef({
        startDate: params.startDate || moment.utc().startOf('isoWeeks'),
        endDate: params.endDate || moment.utc().endOf('days'),
        pageIndex: params.pageIndex || 1,
        pageSize: params.pageSize || 10
    })
    const getData = async () => {
        setIsLoading(true);
        try {
            const response = await getBundleReport({...params, startDate: params.startDate ? moment(params.startDate || "").toISOString() : moment.utc().startOf('isoWeeks').toISOString()
                                                            , endDate: params.endDate ? moment(params.endDate || "").toISOString() :  moment.utc().endOf('days').toISOString()});
            if(response && response?.result) {
                setData(response?.result);
                filterParams.current = {
                    startDate: response?.startDate,
                    endDate: response?.endDate,
                    pageIndex: response?.pageIndex,
                    pageSize: response?.pageSize
                }
                setIsLoading(false);
            }
        } catch (error) {
            setError(error);
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getData();
    },[params])

    const refreshData = () => {
        getData();
    }

    return {data, isLoading, error, refreshData, filterParams}
}